import { date } from 'quasar'
import {
  DATE_FORMAT,
  DATE_DISPLAY_FORMAT,
  DATE_DISPLAY_FORMAT_SHORT,
  STATUS
} from '@/constants'
import { Status } from '@/models/status'

const matchUpperCase = new RegExp(/(?=[A-Z])/)
const isUpperCase = (s:string, any = true) => any ? s ? matchUpperCase.exec(s)?.length !== undefined : false : s && matchUpperCase.exec(s)?.length === s?.length
// @Format - collection of formatting functions
export const capitalize = (string: string) => typeof string !== 'string' ? '' : `${string.charAt(0).toUpperCase()}${string.substring(1)}`
export const titleCase = (string: string, cap = true) => string
  .split(matchUpperCase)
  .map(s => s.split('-')).flat(1)
  // .map(s => s.split('_')).flat(1).map(s => !cap ? s : capitalize(s)).join(' ')
  .map(s => s.split('_')).flat(1).map(s => !cap ? s : capitalize(s)).reduce((str, char) => `${str}${isUpperCase(str[str.length - 1]) && isUpperCase(char) ? '' : ' '}${char}`, '')
export const formatDate = (dateString: Date | string | number | undefined, dateFormat = DATE_DISPLAY_FORMAT) => date.formatDate(dateString, dateFormat)
export const formatStatus = (status: Status, prop?: string) => {
  if (typeof status !== 'string') console.warn(`[utils/template] formatStatus: expected input status to be a status string, but got ${typeof status}`)
  return prop ? (STATUS.get(status)[prop] || STATUS.get(status).label) || '-' : STATUS.get(status).label || '-'
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
CanvasRenderingContext2D.prototype.roundRect = function (x:number, y:number, w:number, h:number, r:number) {
  if (w < 2 * r) r = w / 2
  if (h < 2 * r) r = h / 2
  this.beginPath()
  this.moveTo(x+r, y)
  this.arcTo(x+w, y,   x+w, y+h, r)
  this.arcTo(x+w, y+h, x,   y+h, r)
  this.arcTo(x,   y+h, x,   y,   r)
  this.arcTo(x,   y,   x+w, y,   r)
  this.closePath()
  return this
}

export const getCanvasDPI = () => {
  const ctx = document.createElement('canvas').getContext('2d')
  const dpr = window.devicePixelRatio || 1
  if (!ctx) return 1
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const bsr = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1

  return dpr / bsr
}

export const createCanvas = (options, append = true) => {
  const { width, height, id = Date.now().toString(16) + Math.random().toFixed() } = options
  const canvasId = id
  const dpi = getCanvasDPI()
  const canvas = document.createElement('canvas')
  canvas.id = canvasId

  canvas.width = width * dpi
  canvas.height = height * dpi
  canvas.style.width = `${width}px`
  canvas.style.height = `${height}px`

  const context = canvas.getContext('2d')
  if (!context) throw Error('Failed to get canvas context')
  context.setTransform(dpi, 0, 0, dpi, 0, 0)

  if (append) document.body.append(canvas)
  return {id: canvasId, canvas, context, dpi}
}

export const format = {
  capitalize,
  date: formatDate,
  status: formatStatus,
  title: titleCase
}
